/* FrunkVault — LP v2 behaviour
 *
 * Three jobs, no dependencies:
 *   1. Vault configurator — one finish choice drives image, price, and which
 *      product form is armed (Core and Signature are separate Shopify products).
 *   2. AJAX add to cart -> slide-out drawer, so a visitor who adds never leaves
 *      the landing page.
 *   3. Sticky mobile buy bar that mirrors the hero configurator exactly.
 *
 * Every enhancement is additive: with JS disabled the first product form still
 * posts to /cart and the page remains a working buy box.
 */
(function () {
  'use strict';

  var MONEY = window.FV_MONEY_FORMAT || '${{amount}}';
  var CART_URL = window.FV_CART_URL || '/cart';
  var offerPricing = window.FVOfferPricing;
  var LAUNCH_OFFER = Boolean(offerPricing && offerPricing.active);
  var LAUNCH_DISCOUNT_CENTS = offerPricing ? offerPricing.discountCents : 0;
  var LAUNCH_OFFER_MESSAGE = offerPricing ? offerPricing.message : '';
  var LAUNCH_CHECKOUT_MESSAGE = offerPricing ? offerPricing.checkoutMessage : '';

  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2);
    var withCommas = function (n) {
      var parts = n.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return parts.join('.');
    };
    return MONEY
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, withCommas((cents / 100).toFixed(0)))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withCommas(value))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, (cents / 100).toFixed(0))
      .replace(/\{\{\s*amount\s*\}\}/g, withCommas(value));
  }

  function isDeepSpace(entry) {
    return !!entry && String(entry.variant) === '46706791121057';
  }

  function displayPrice(entry) {
    if (!entry) return '';
    var cents = Number(entry.priceCents);
    if (!LAUNCH_OFFER || !Number.isFinite(cents)) return entry.priceShort || entry.price;
    return offerPricing.formatMoney(offerPricing.priceFor(cents), true);
  }

  function updateStaticOfferCopy(entry) {
    if (!entry) return;
    var price = displayPrice(entry);
    document.querySelectorAll('[data-vault-stake-price], [data-vault-comparison-price]').forEach(function (el) {
      el.textContent = price;
    });
  }


  /* ------------------------------------------------------------------ */
  /* Cart drawer                                                         */
  /* ------------------------------------------------------------------ */

  var Drawer = (function () {
    var root = document.querySelector('[data-cart-drawer]');
    if (!root) return { open: function () {}, available: false };

    var panel = root.querySelector('.cart-drawer__panel');
    var itemsEl = root.querySelector('[data-cart-items]');
    var subtotalEl = root.querySelector('[data-cart-subtotal]');
    var titleEl = root.querySelector('[data-cart-drawer] .cart-drawer__title');
    var lastFocus = null;

  function render(cart) {
    itemsEl.innerHTML = '';
    var expectedSavings = 0;

      if (!cart.items.length) {
        var empty = document.createElement('p');
        empty.className = 'cart-drawer__empty';
        empty.textContent = 'Your cart is empty.';
        itemsEl.appendChild(empty);
      }

      cart.items.forEach(function (item) {
        var row = document.createElement('div');
        row.className = 'cart-drawer__item';

        var media = document.createElement('div');
        media.className = 'cart-drawer__item-media';
        if (item.image) {
          var img = document.createElement('img');
          img.src = item.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_200x$1');
          img.alt = item.product_title;
          img.loading = 'lazy';
          media.appendChild(img);
        }

        var info = document.createElement('div');
        info.className = 'cart-drawer__item-info';

        var title = document.createElement('p');
        title.className = 'cart-drawer__item-title';
        title.textContent = item.product_title;

        var variant = document.createElement('p');
        variant.className = 'cart-drawer__item-variant';
        var variantBits = [];
        if (item.variant_title) variantBits.push(item.variant_title);
        variantBits.push('Qty ' + item.quantity);
        variant.textContent = variantBits.join(' · ');

        var shippingText = String(item.variant_id) === '46706791121057' && item.properties && item.properties['Shipping'];
        var shippingEl = null;
        if (shippingText) {
          shippingEl = document.createElement('p');
          shippingEl.className = 'cart-drawer__item-preorder';
          shippingEl.textContent = shippingText;
        }

        var displayedLinePrice = Number(item.final_line_price);
        var itemIsEligible = item.product_type === 'Frunk Protection';
        // Automatic Shopify discounts can be reflected in final_line_price
        // before discount_allocations is populated in the Ajax cart response.
        // final_line_price is therefore the source of truth: relying only on
        // the allocations array would display a second $20 reduction here.
        var hasShopifyDiscount = Number(item.final_line_price) < Number(item.original_line_price);
        if (LAUNCH_OFFER && itemIsEligible && !hasShopifyDiscount) {
          var itemDiscount = Math.min(Number(item.original_line_price || item.final_line_price), LAUNCH_DISCOUNT_CENTS * item.quantity);
          displayedLinePrice -= itemDiscount;
          expectedSavings += itemDiscount;
        }

        var price = document.createElement('p');
        price.className = 'cart-drawer__item-price';
        price.textContent = formatMoney(displayedLinePrice);

        info.appendChild(title);
        info.appendChild(variant);
        if (shippingEl) info.appendChild(shippingEl);
        info.appendChild(price);
        row.appendChild(media);
        row.appendChild(info);
        itemsEl.appendChild(row);
      });

      if (cart.total_discount > 0) expectedSavings = 0;
      subtotalEl.textContent = formatMoney(Math.max(0, cart.total_price - expectedSavings));
      var drawerOffer = root.querySelector('[data-cart-drawer-offer]');
      if (drawerOffer) drawerOffer.textContent = LAUNCH_OFFER
        ? LAUNCH_CHECKOUT_MESSAGE + ' · Taxes at checkout'
        : 'Shipping included · Taxes at checkout';
      if (titleEl) {
        titleEl.textContent = cart.item_count === 1 ? 'Added to cart' : 'Your cart · ' + cart.item_count + ' items';
      }

      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
    }

    function open() {
      root.hidden = false;
      lastFocus = document.activeElement;
      // Next frame so the transition actually runs.
      requestAnimationFrame(function () {
        root.classList.add('is-open');
        document.documentElement.classList.add('cart-drawer-open');
        if (panel) panel.focus();
      });
    }

    function close() {
      root.classList.remove('is-open');
      document.documentElement.classList.remove('cart-drawer-open');
      window.setTimeout(function () {
        root.hidden = true;
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      }, 260);
    }

    function focusableElements() {
      return Array.prototype.slice.call(panel.querySelectorAll(
        'a[href], area[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), iframe, object, embed, [contenteditable], [tabindex]:not([tabindex="-1"])'
      )).filter(function (el) {
        return el.getAttribute('aria-hidden') !== 'true' && el.offsetParent !== null;
      });
    }

    root.querySelectorAll('[data-cart-close]').forEach(function (btn) {
      btn.addEventListener('click', close);
    });

    document.addEventListener('keydown', function (e) {
      if (!root.classList.contains('is-open')) return;
      if (e.key === 'Escape') {
        close();
        return;
      }
      if (e.key !== 'Tab' || !panel) return;

      var focusables = focusableElements();
      if (!focusables.length) {
        e.preventDefault();
        panel.focus();
        return;
      }

      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey) {
        if (document.activeElement === first || !panel.contains(document.activeElement)) {
          e.preventDefault();
          last.focus();
        }
      } else if (document.activeElement === last || !panel.contains(document.activeElement)) {
        e.preventDefault();
        first.focus();
      }
    });

    function refresh() {
      return fetch(CART_URL + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { render(cart); return cart; });
    }

    return { open: open, close: close, refresh: refresh, available: true };
  })();

  /* ------------------------------------------------------------------ */
  /* Configurator                                                        */
  /* ------------------------------------------------------------------ */

  function initConfigurator(root) {
    var dataEl = root.querySelector('[data-vault-data]');
    if (!dataEl) return null;

    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (err) { return null; }

    root.querySelectorAll('[data-vault-option-price]').forEach(function (el) {
      var entry = data[el.getAttribute('data-vault-option-price')];
      if (entry) el.textContent = displayPrice(entry);
    });
    root.querySelectorAll('[data-vault-tier-price]').forEach(function (el) {
      var tier = el.getAttribute('data-vault-tier-price');
      var entry = Object.keys(data).map(function (key) { return data[key]; }).find(function (item) { return item.tier === tier; });
      if (entry) el.textContent = displayPrice(entry);
    });

    var swatches = Array.prototype.slice.call(root.querySelectorAll('[data-vault-swatch]'));
    var nameEl = root.querySelector('[data-vault-name]');
    var noteEl = root.querySelector('[data-vault-note]');
    var priceEl = root.querySelector('[data-vault-price]');
    var priceNoteEl = root.querySelector('[data-vault-price-note]');
    var compareEl = root.querySelector('[data-vault-compare]');
    var stageTag = root.querySelector('[data-vault-stagetag]');
    var statusEl = root.querySelector('[data-vault-status]');
    var shippingNoteEl = root.querySelector('[data-vault-shipping-note]');
    var notifyEl = root.querySelector('[data-restock-notify]');
    var mobileHero = root.closest('.hero-buy--product-first');
    var mobilePriceEl = mobileHero
      ? mobileHero.querySelector('[data-vault-mobile-price]')
      : null;
    var mobileTitleEl = mobileHero
      ? mobileHero.querySelector('[data-vault-mobile-title]')
      : null;
    var mobileDefault = root.getAttribute('data-vault-mobile-default');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-vault-slide]'));
    var installSlide = root.querySelector('[data-vault-install-slide]');
    var installToggle = root.querySelector('[data-vault-toggle-install]');
    var installLabel = root.querySelector('[data-vault-install-label]');
    var galleryButtons = Array.prototype.slice.call(root.querySelectorAll('[data-vault-gallery]'));
    var currentGalleryImage = root.querySelector('[data-vault-gallery-current]');
    var wraps = Array.prototype.slice.call(root.querySelectorAll('[data-vault-form-for]'));
    var galleryMode = 'product';

    var api = { root: root, current: null, currentKey: null, data: data };

    function selectGalleryButton(name) {
      galleryButtons.forEach(function (button) {
        var on = button.getAttribute('data-vault-gallery') === name;
        button.classList.toggle('is-active', on);
        button.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    function syncInstallControl(showingInstall) {
      root.classList.toggle('is-install-view', showingInstall);
      if (installToggle) installToggle.setAttribute('aria-expanded', showingInstall ? 'true' : 'false');
      if (installLabel) installLabel.textContent = showingInstall ? 'Back to product' : 'See it installed';
    }

    function showCurrentProduct(gallerySelection) {
      if (!api.currentKey) return;
      galleryMode = 'product';
      slides.forEach(function (slide) {
        var on = slide.getAttribute('data-vault-slide') === api.currentKey;
        slide.classList.toggle('is-active', on);
        if (on) { slide.removeAttribute('aria-hidden'); } else { slide.setAttribute('aria-hidden', 'true'); }
      });
      if (installSlide) {
        installSlide.classList.remove('is-active');
        installSlide.setAttribute('aria-hidden', 'true');
      }
      syncInstallControl(false);
      selectGalleryButton(gallerySelection || 'product');
    }

    function showInstallView() {
      if (!installSlide) return;
      galleryMode = 'install';
      slides.forEach(function (slide) {
        slide.classList.remove('is-active');
        slide.setAttribute('aria-hidden', 'true');
      });
      installSlide.classList.add('is-active');
      installSlide.removeAttribute('aria-hidden');
      syncInstallControl(true);
      selectGalleryButton('install');
    }

    function apply(key, gallerySelection) {
      var entry = data[key];
      if (!entry) return;
      api.current = entry;
      api.currentKey = key;
      showCurrentProduct(gallerySelection);

      if (currentGalleryImage && entry.image) {
        currentGalleryImage.src = entry.image;
        currentGalleryImage.alt = entry.name + ' FrunkVault finish';
      }

      if (nameEl) nameEl.textContent = entry.name;
      if (noteEl) noteEl.textContent = entry.note || '';
      if (priceEl) priceEl.textContent = displayPrice(entry);
      if (mobilePriceEl) mobilePriceEl.textContent = displayPrice(entry);
      if (mobileTitleEl) {
        var signatureTitle = mobileTitleEl.getAttribute('data-vault-mobile-signature-title') || 'FrunkVault Signature';
        var coreTitle = mobileTitleEl.getAttribute('data-vault-mobile-core-title') || 'FrunkVault Core';
        mobileTitleEl.textContent = String(entry.tier || '').toLowerCase() === 'core' ? coreTitle : signatureTitle;
      }
      if (priceNoteEl) priceNoteEl.textContent = LAUNCH_OFFER
        ? LAUNCH_OFFER_MESSAGE + ' · Applied automatically at checkout'
        : (priceNoteEl.getAttribute('data-default-price-note') || '');
      if (stageTag) stageTag.textContent = entry.title + ' · ' + entry.name;

      if (compareEl) {
        if (LAUNCH_OFFER) { compareEl.textContent = offerPricing.formatMoney(entry.priceCents); compareEl.hidden = false; }
        else if (entry.compare) { compareEl.textContent = entry.compare; compareEl.hidden = false; }
        else { compareEl.hidden = true; }
      }

      wraps.forEach(function (wrap) {
        var on = wrap.getAttribute('data-vault-form-for') === entry.handle;
        wrap.classList.toggle('is-hidden', !on);
        if (!on) return;
        var idInput = wrap.querySelector('[data-vault-variant]');
        if (idInput) idInput.value = entry.variant;
        var btn = wrap.querySelector('[data-vault-add]');
        var label = wrap.querySelector('[data-vault-addlabel]');
        if (btn) btn.disabled = !entry.available;
        if (label) label.textContent = entry.available ? 'Add to cart — ' + displayPrice(entry) : 'Sold out';
        var showShippingNote = isDeepSpace(entry);
        wrap.querySelectorAll('[data-vault-deep-space-shipping]').forEach(function (input) { input.disabled = !showShippingNote; });
        var express = wrap.querySelector('[data-vault-express]');
        if (express) express.hidden = false;
      });

      if (shippingNoteEl) shippingNoteEl.hidden = !isDeepSpace(entry);
      if (notifyEl) {
        // Keep the confirmation visible after a signup reloads the page.
        var posted = !!notifyEl.querySelector('[data-restock-success]') && window.location.hash.indexOf('RestockNotify') !== -1;
        notifyEl.hidden = !posted && entry.available;
        var notifyName = notifyEl.querySelector('[data-restock-name]');
        if (notifyName) notifyName.textContent = entry.name;
        var notifyTags = notifyEl.querySelector('[data-restock-tags]');
        if (notifyTags) notifyTags.value = 'restock-waitlist, restock-' + key;
      }

      if (statusEl) { statusEl.hidden = true; statusEl.textContent = ''; }
      root.dispatchEvent(new CustomEvent('vault:change', { bubbles: true, detail: entry }));
    }

    swatches.forEach(function (input) {
      input.addEventListener('change', function () { if (input.checked) apply(input.value); });
    });

    galleryButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var target = button.getAttribute('data-vault-gallery');
        if (target === 'install') {
          showInstallView();
          return;
        }
        if (target === 'product') {
          showCurrentProduct('product');
          return;
        }
        if (!data[target]) return;
        var targetInput = swatches.filter(function (input) { return input.value === target; })[0];
        if (targetInput) targetInput.checked = true;
        apply(target, target);
      });
    });

    if (installToggle) {
      installToggle.addEventListener('click', function () {
        if (galleryMode === 'install') showCurrentProduct('product');
        else showInstallView();
      });
    }

    var checked = swatches.filter(function (i) { return i.checked; })[0] || swatches[0];
    if (checked) { checked.checked = true; apply(checked.value); }

    function applyMobileDefault() {
      if (!mobileDefault || !data[mobileDefault] || !window.matchMedia || !window.matchMedia('(max-width: 560px)').matches) return;
      var mobileInput = swatches.filter(function (input) { return input.value === mobileDefault; })[0];
      if (!mobileInput) return;
      mobileInput.checked = true;
      apply(mobileDefault);
    }

    applyMobileDefault();
    if (mobileDefault && window.matchMedia) {
      var mobileMedia = window.matchMedia('(max-width: 560px)');
      var handleMobileChange = function (event) { if (event.matches) applyMobileDefault(); };
      if (mobileMedia.addEventListener) mobileMedia.addEventListener('change', handleMobileChange);
      else if (mobileMedia.addListener) mobileMedia.addListener(handleMobileChange);
    }

    api.activeForm = function () {
      var wrap = wraps.filter(function (w) { return !w.classList.contains('is-hidden'); })[0];
      return wrap ? wrap.querySelector('form') : null;
    };
    api.apply = apply;

    return api;
  }

  /* ------------------------------------------------------------------ */
  /* AJAX add to cart                                                    */
  /* ------------------------------------------------------------------ */

  function submitControls(form, button, externalButton) {
    var controls = [];
    function add(control) {
      if (control && controls.indexOf(control) === -1) controls.push(control);
    }
    add(button);
    form.querySelectorAll('[data-vault-add]').forEach(add);
    add(externalButton);
    return controls;
  }

  function submitForm(form, button, externalButton) {
    if (!form || form.dataset.fvAdding === 'true') return;
    form.dataset.fvAdding = 'true';

    var label = button ? button.querySelector('[data-vault-addlabel]') : null;
    var original = label ? label.textContent : null;
    var externalOriginal = externalButton ? externalButton.textContent : null;
    var controls = submitControls(form, button, externalButton);
    var added = false;

    controls.forEach(function (control) {
      control.dataset.fvWasDisabled = control.disabled ? 'true' : 'false';
      control.disabled = true;
    });

    if (label) label.textContent = 'Adding…';
    if (externalButton) externalButton.textContent = 'Adding…';

    function restoreControls() {
      controls.forEach(function (control) {
        control.disabled = control.dataset.fvWasDisabled === 'true';
        delete control.dataset.fvWasDisabled;
      });
      if (label && original) label.textContent = original;
      if (externalButton && externalOriginal) externalButton.textContent = externalOriginal;
      delete form.dataset.fvAdding;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (res) {
        return res.json().then(function (body) {
          if (!res.ok) throw new Error(body.description || body.message || 'Could not add to cart.');
          return body;
        });
      })
      .then(function () {
        added = true;
        return Drawer.refresh();
      })
      .then(function () {
        Drawer.open();
      })
      .catch(function (err) {
        var status = form.closest('.vault-cfg')
          ? form.closest('.vault-cfg').querySelector('[data-vault-status]')
          : null;
        // An add can succeed even when the nonessential drawer refresh fails.
        // Never submit this form again in that case: it would add a duplicate.
        if (added) {
          if (status) {
            status.textContent = 'Added to cart. Opening your cart…';
            status.hidden = false;
          }
          window.location.assign(CART_URL);
          return;
        }
        if (status) {
          status.textContent = err.message;
          status.hidden = false;
        } else {
          // This path should be unreachable for a vault form, but redirecting
          // to the cart is safer than replaying an uncertain add request.
          window.location.assign(CART_URL);
        }
      })
      .finally(restoreControls);
  }

  /* ------------------------------------------------------------------ */
  /* Boot                                                                */
  /* ------------------------------------------------------------------ */

  var configurators = [];

  function boot(scope) {
    (scope || document).querySelectorAll('[data-vault-cfg]').forEach(function (root) {
      if (root.dataset.vaultReady === 'true') return;
      root.dataset.vaultReady = 'true';
      var api = initConfigurator(root);
      if (api) configurators.push(api);
    });
  }

  boot();
  // The hero configurator's selected finish, not the first data entry (Core):
  // otherwise "$169 today" sits beside a pre-selected $189 Signature finish.
  var primaryEntry = configurators[0] ? configurators[0].current : null;
  updateStaticOfferCopy(primaryEntry);
  if (configurators[0]) {
    configurators[0].root.addEventListener('vault:change', function (event) {
      updateStaticOfferCopy(event.detail);
    });
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('.vault-cfg__form');
    if (!form || !Drawer.available) return;
    e.preventDefault();
    submitForm(form, form.querySelector('[data-vault-add]'));
  });

  /* ------------------------------------------------------------------ */
  /* Sticky mobile buy bar — mirrors the FIRST configurator on the page   */
  /* ------------------------------------------------------------------ */

  (function () {
    var bar = document.querySelector('[data-buy-bar]');
    var primary = configurators[0];
    if (!bar || !primary) return;

    var nameEl = bar.querySelector('[data-buy-bar-name]');
    var priceEl = bar.querySelector('[data-buy-bar-price]');
    var addBtn = bar.querySelector('[data-buy-bar-add]');

    function sync(entry) {
      if (!entry) return;
      if (nameEl) nameEl.textContent = entry.name + ' · ' + entry.tier;
      if (priceEl) priceEl.textContent = displayPrice(entry);
      if (addBtn) {
        addBtn.disabled = !entry.available;
        addBtn.textContent = entry.available ? 'Add to cart' : 'Sold out';
      }
    }

    sync(primary.current);
    primary.root.addEventListener('vault:change', function (e) { sync(e.detail); });

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var form = primary.activeForm();
        submitForm(form, form ? form.querySelector('[data-vault-add]') : null, addBtn);
      });
    }

    function setVisible(visible) {
      bar.classList.toggle('is-visible', visible);
      bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
    }

    setVisible(false);

    var sentinel = primary.root.querySelector('.vault-cfg__panel') || primary.root;

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        setVisible(!entries[0].isIntersecting);
      }, { threshold: 0 });
      io.observe(sentinel);
    } else {
      var update = function () { setVisible(sentinel.getBoundingClientRect().bottom <= 0); };
      update();
      window.addEventListener('scroll', update, { passive: true });
    }

    // Never let the bar cover the closing offer's own buy button.
    var closer = document.querySelector('.closing-offer');
    if (closer && 'IntersectionObserver' in window) {
      var io2 = new IntersectionObserver(function (entries) {
        bar.classList.toggle('is-suppressed', entries[0].isIntersecting);
      }, { threshold: 0.15 });
      io2.observe(closer);
    }
  })();

  /* ------------------------------------------------------------------ */
  /* Repair-partner dent loop                                            */
  /* ------------------------------------------------------------------ */

  /* The element carries `autoplay muted playsinline`, so the BROWSER starts the
     loop. This block only trims the edges of that behaviour — it must never be
     what playback depends on. An earlier version drove play() from here with no
     autoplay attribute, and anything that declined the scripted call (iOS in
     Low Power or Low Data Mode, most obviously) was left on a frozen poster.

     What is left: pause the loop while it is off screen so a ~3 MB asset is not
     decoding unseen, and stop it outright under prefers-reduced-motion. Both
     degrade safely — with JS broken the browser just loops it as authored. */
  (function () {
    var loops = document.querySelectorAll('[data-repair-loop]');
    if (!loops.length) return;

    var play = function (v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); };

    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      Array.prototype.forEach.call(loops, function (v) {
        v.removeAttribute('autoplay');
        v.pause();
      });
      return;
    }

    if (!('IntersectionObserver' in window)) return;

    /* Only pause a loop that has actually been seen. An observer fires once
       on page load for every target, and for this below-the-fold video that
       first report is always "not intersecting" — pausing on it cancels the
       browser's native autoplay before it ever starts, quietly putting
       playback back on the scripted play() path. Chrome and Safari already
       hold muted autoplay video that is off screen, so there is nothing to
       save before the first view. */
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        if (entry.isIntersecting) { v.fvSeen = true; play(v); }
        else if (v.fvSeen) v.pause();
      });
    }, { threshold: 0.2 });

    Array.prototype.forEach.call(loops, function (v) { io.observe(v); });
  })();
})();
